import { render, staticRenderFns } from "./AppStoreDownloadButton.vue?vue&type=template&id=7c0c5718&scoped=true&"
import script from "./AppStoreDownloadButton.vue?vue&type=script&lang=js&"
export * from "./AppStoreDownloadButton.vue?vue&type=script&lang=js&"
import style0 from "./AppStoreDownloadButton.vue?vue&type=style&index=0&id=7c0c5718&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c5718",
  null
  
)

export default component.exports